import React from 'react';

export const UpdateConservationActionModeledUpliftActivityFeedItemDescription = props => {

    const {CustomEventData: data , Event: event } = props;    
    const action = data?.action ?? "modified";

    return <p>
        {event?.Activity?.User?.name ?? event?.fulcrumUsername ?? "StreamBank"} {action} a Modeled Uplift.
    </p>;
};

